<template>
  <div>
    <!-- Support PC Tablet -->
    <div
      v-if="true"
      class="language"
      :class="{ showing: !isShow, langshowbottom: ispositionbottom }"
    >
      <div v-if="isPH">
        <select
          v-model="locale"
          crm_at="language"
          class="select-language"
          :class="{ 'select-bottom': ispositionbottom }"
          @change="handleLanguage"
        >
          <option crm_at="language_ph" value="ph">PH</option>
          <option crm_at="language_en" value="ph_en">EN</option>
        </select>
      </div>
      <div v-else>
        <select
          v-model="locale"
          crm_at="language"
          class="select-language"
          :class="{ 'select-bottom': ispositionbottom }"
          @change="handleLanguage"
        >
          <option crm_at="language_th" value="th">TH</option>
          <option crm_at="language_en" value="en">EN</option>
        </select>
      </div>
      <div class="wrapper__bzb__logo">
        <img
          class="bzb_logo_language"
          crm_at="bzb_logo_language"
          src="../../assets/images/bzbs-logo-new.png"
          alt="bzb__logo_edit"
        />
      </div>
    </div>

    <!-- Support Mobile -->
    <div
      v-else
      class="language"
      :class="{ showing: !isShow, langshowbottom: ispositionbottom }"
    >
      <div v-if="isPH">
        <select
          crm_at="language"
          class="select-language"
          :class="{ 'select-bottom': ispositionbottom }"
          @change="handleLanguage"
        >
          <option crm_at="language_ph" value="ph">PH</option>
          <option crm_at="language_en" value="ph_en">EN</option>
        </select>
      </div>
      <div v-else>
        <select
          crm_at="language"
          class="select-language"
          :class="{ 'select-bottom': ispositionbottom }"
          @change="handleLanguage"
        >
          <option crm_at="language_th" value="th">TH</option>
          <option crm_at="language_en" value="en">EN</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Cache from '@/helper/Cache.js'
import Vue from 'vue'
import Account from '@/helper/AccountHelper.js'

export default {
  name: 'ChangeLanguage',
  KEY_COOKIE_LOCALE: 'BzbsLocale',
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    isShow: Boolean,
    ispositionbottom: Boolean,
  },
  data() {
    return {
      locale: '',
      isPH: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.locale = Cache.get('BzbsLocale')
      this.isPH = Vue.bzbsConfig.businessRule.webFor.PH
    },
    handleLanguage() {
      Account.bzbsAnalyticTracking(
        'home_page',
        'home_page_change_language',
        'change_language',
        'on change',
      )
      this.handleLoading(true)
      Vue.$cookies.set(
        'BzbsLocale',
        this.locale,
        null,
        null,
        null,
        true,
        'Strict',
      )
      window.location.reload()
    },
  },
}
</script>
<style lang="scss">
@import '@/style/_mixin.scss';
.language {
  z-index: 2;
  width: 100%;

  &.showing {
    display: none;
  }

  .select-language {
    width: 60px;
    margin: 10px 10px 0px 0px;
    padding: 4px 8px;
    border-radius: 4px;
  }
  .select-bottom {
    width: 60px;
    float: left;
    margin: 20px 10px 10px 15px;
  }

  .ant-select-selection {
    height: 30px !important;
  }

  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
    background-color: #fff;
    bottom: 0;
    position: fixed;
    top: initial;
    text-align: initial;

    .select-language {
      width: 60px;
      float: left;
      margin: 6px 0px 6px 10px;
    }

    .wrapper__bzb__logo {
      float: right;
    }

    .bzb_logo_language {
      height: 24px;
      margin: 10px 10px 8px 0px;
    }
  }
  background-color: #fff;
  bottom: 0;
  position: fixed;
  top: initial;
  text-align: initial;

  .select-language {
    width: 60px;
    float: left;
    margin: 6px 0px 6px 10px;
  }

  .wrapper__bzb__logo {
    float: right;
  }

  .bzb_logo_language {
    height: 24px;
    margin: 10px 10px 8px 0px;
  }
}
.langshowbottom {
  bottom: 6px !important;
}
</style>
